import { render, staticRenderFns } from "./EditDate.vue?vue&type=template&id=4306745a&"
import script from "./EditDate.vue?vue&type=script&lang=js&"
export * from "./EditDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports